import React, { useContext, useEffect } from "react";
import { httpGetUnsecure } from "Utils/HttpFunctions";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { authContext } from "context/Auth";
import loggingInDev from "loggingInDev";
import { integrationContext } from "context/Integrations";
import useStyle from "./styles";

export default function TeamsSignin() {
  const navigate = useNavigate();
  const { isLogged } = useContext(authContext);
  const { getUser } = useContext(integrationContext);
  const classes = useStyle();

  useEffect(() => {
    getAuth();
  }, [isLogged]);

  const getAuth = async () => {
    if (isLogged === true) {
      loggingInDev("window location ==>", window.location);
      const path = `/outlook/teams/callback${
        window.location.search
      }&userId=${localStorage.getItem("user_id")}`;
      const response = await httpGetUnsecure(path);
      if (response && response.constructor !== String) {
        const data = response.data.user;
        loggingInDev("data ===> ", data);
        await getUser();
        navigate("/preferences", { replace: true });
      } else {
        navigate("/dashboard");
      }
    }
  };

  return (
    <div className={classes.centerLoader}>
      <CircularProgress />
    </div>
  );
}
